import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  IconButton,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const BackNavigationModal = ({ open, onClose, onExitWithoutFeedback, currentReportIndex }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={() => {}} // Do nothing on backdrop click or escape key
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: isMobile ? '20px' : '32px',
          width: isMobile ? '85vw' : '400px',
          height: 'auto',
          maxWidth: isMobile ? '85vw' : '400px',
          position: 'relative',
          margin: isMobile ? '16px' : 'auto',
          boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
          border: 'none'
        }
      }}
    >
      {/* Close button - closes modal and stays on same page */}
      <IconButton
        onClick={onClose} // Close the modal and stay on page
        sx={{
          position: 'absolute',
          top: isMobile ? 12 : 16,
          right: isMobile ? 12 : 16,
          color: '#051572',
          fontSize: isMobile ? '20px' : '24px',
          '&:hover': {
            backgroundColor: 'rgba(5, 21, 114, 0.08)'
          }
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ padding: 0, textAlign: 'center' }}>
        {/* Warning Icon */}
        <Box sx={{ marginBottom: isMobile ? '20px' : '24px', marginTop: isMobile ? '8px' : '0px' }}>
          <Box
            sx={{
              width: isMobile ? '64px' : '72px',
              height: isMobile ? '64px' : '72px',
              borderRadius: '50%',
              border: `${isMobile ? '3px' : '4px'} solid #C40320`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              backgroundColor: '#FFF',
              boxShadow: '0px 2px 8px rgba(196, 3, 32, 0.15)'
            }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '32px' : '36px',
                fontWeight: 'bold',
                color: '#C40320'
              }}
            >
              !
            </Typography>
          </Box>
        </Box>

        {/* Title */}
        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          component="div"
          sx={{
            fontWeight: 600,
            marginBottom: isMobile ? '16px' : '20px',
            color: '#1a1a1a',
            fontSize: isMobile ? '20px' : '24px'
          }}
        >
          Quick <span style={{ color: '#C40320' }}>Reminder</span>
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            fontSize: isMobile ? '14px' : '16px',
            color: '#666666',
            marginBottom: isMobile ? '24px' : '28px',
            lineHeight: 1.5,
            paddingX: isMobile ? '4px' : '8px',
            fontWeight: 400
          }}
        >
          Please add your input and feedback for the AI Inference in{' '}
          <span style={{ 
            textDecoration: 'underline', 
            fontWeight: 600,
            color: '#051572'
          }}>
            Report {currentReportIndex}
          </span>
        </Typography>

        {/* Buttons */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'row',
          gap: isMobile ? '8px' : '16px', 
          justifyContent: 'center',
          paddingX: isMobile ? '0px' : '8px'
        }}>
          {/* Exit without feedback button */}
          <Button
            onClick={onExitWithoutFeedback}
            variant="outlined"
            sx={{
              borderRadius: '8px',
              border: '2px solid #9F0101',
              color: '#9F0101',
              backgroundColor: '#FFF',
              padding: isMobile ? '8px 6px' : '10px 20px',
              fontSize: isMobile ? '11px' : '15px',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: isMobile ? '48%' : '170px',
              height: '40px',
              flex: isMobile ? 1 : 'none',
              boxShadow: 'none',
              whiteSpace: isMobile ? 'normal' : 'nowrap',
              lineHeight: isMobile ? '1.2' : 'normal',
              '&:hover': {
                border: '2px solid #9F0101',
                backgroundColor: 'rgba(159, 1, 1, 0.04)',
                boxShadow: '0px 2px 8px rgba(159, 1, 1, 0.15)'
              }
            }}
          >
            {isMobile ? 'Exit without feedback' : 'Exit without feedback'}
          </Button>

          {/* View Report button */}
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              borderRadius: '8px',
              backgroundColor: '#051572',
              color: '#FFF',
              padding: isMobile ? '8px 12px' : '10px 20px',
              fontSize: isMobile ? '13px' : '15px',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: isMobile ? '48%' : '170px',
              height: '40px',
              flex: isMobile ? 1 : 'none',
              boxShadow: '0px 2px 8px rgba(5, 21, 114, 0.25)',
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: '#041461',
                boxShadow: '0px 4px 12px rgba(5, 21, 114, 0.35)'
              }
            }}
          >
            View Report
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BackNavigationModal; 